module.exports = __webpack_public_path__ + "static/media/DAK-WAL.93804ba0.jpg";